// @flow

import CheckboxWidget from "./checkbox";
import DatePickerWidget from "./date-picker";
import HoursAndMinutesSelectWidget from "./hours-and-minutes-select";
import HoursAndMinutesSelectOptimised from "./hours-and-minutes-select-optimised";

import IconButtonWidget from "./icon-button";
import NumberWidget from "./number";
import SecondsAsHoursInput from "./seconds-as-hours-input";
import SelectWidget from "./select";
import SelectOptimised from "./select-optimised";
import SwitchWidget from "./switch";
import TextWidget from "./text";
import TextArrayWidget from "./text-array";
import TextareaWidget from "./textarea";

import CustomAnswerTypeSwitchWidget from "./custom-answer-type-switch";

const defaultWidgets = {
  checkbox: CheckboxWidget,
  "date-picker": DatePickerWidget,
  "hours-and-minutes-select": HoursAndMinutesSelectWidget,
  "hours-and-minutes-select-optimised": HoursAndMinutesSelectOptimised,
  "icon-button": IconButtonWidget,
  number: NumberWidget,
  "seconds-as-hours-input": SecondsAsHoursInput,
  select: SelectWidget,
  "select-optimised": SelectOptimised,
  switch: SwitchWidget,
  text: TextWidget,
  "text-array": TextArrayWidget,
  textarea: TextareaWidget,
};

const customWidgets = {
  "custom-answer-type-switch": CustomAnswerTypeSwitchWidget,
};

export default {
  ...defaultWidgets,
  ...customWidgets,
};
